//---------------------------------------------
// Notifications Module 
//---------------------------------------------
// Módulo para gerenciar as notificacoes

import axios from '../../services/api';
import Cookies from 'js-cookie';
// var qs = require('qs');
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    listInstiRequests: [],
    listUserRequests: [],


    //VERIFICACOES
    isSentRequestUserInsti: null,
    isSentRequestInstiUser: null,

})

// MUTATIONS
const mutations = {
    //-- MUTATION REQUISICAO DE TODAS AS SOLICITACOES DA INSTI
    setListInstiRequests(state, payload) {
        state.listInstiRequests = payload
    },

    //-- MUTATION REQUISICAO DE TODAS AS SOLICITACOES DO USER
    setListUserRequests(state, payload) {
        state.listUserRequests = payload
    },


    //-- MUTATION PARA SETAR VALIDACAO DO ENVIO USER -> INSTI
    setIsSentRequestUserInsti(state, payload) {
        state.isSentRequestUserInsti = payload
    },

    //-- MUTATION PARA SETAR VALIDACAO DO ENVIO USER -> INSTI
    setIsSentRequestInstiUser(state, payload) {
        state.isSentRequestInstiUser = payload
    }
}

// ACTIONS
const actions = {
    //-- ACTION REQUISICAO DE SOLICITACAO (USER PEDINDO PRA ENTRAR NUMA INSTI)
    async setNotifyUserJoinInsti({commit}, payload) {
        await axios
            .post(`notificacoes/user`, {
                idInstituicao: payload.idInstituicao,
                notiType: 'USUARIO_INSTITUICAO'
            }, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
                commit('setIsSentRequestUserInsti', true)
            })
            .catch(() => {
                commit('setIsSentRequestUserInsti', false)
            })
    },

    //-- ACTION REQUISICAO DE SOLICITACAO (USER PEDINDO PRA ENTRAR NUM GRUPO)
    async setNotifyUserJoinGrupo(_, payload) {
        await axios
            .post(`notificacoes/user`, {
                idGrupo: payload.idGrupo,
                notiType: 'USUARIO_GRUPO'
            }, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION INVITE USUÁRIO PARA A PLATAFORMA
    //-- Adm Estadual => 6
    async setInviteEstadualUser({commit}, payload) {
        await axios
            .post(`usuarios/register-invite/${payload.userMails}?inviteEstadual=true&idPermissao=${payload.idPermissao}`, {}, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                if(response.data === false) {
                    commit('setIsSentRequestInstiUser', true)
                } else {
                    commit('setIsSentRequestInstiUser', false)
                }
            })
            .catch((error) => {
                console.log(error.message)
                commit('setIsSentRequestInstiUser', false)
            })
    },
    
    //-- ACTION INVITE USUÁRIO PARA A PLATAFORMA
    //-- Adm Regional => 5
    async setNotifyInstiInviteUser({commit}, payload) {
        await axios
            .post(`usuarios/register-invite/${payload.userMails}?idRegional=${payload.idRegional}&idPermissao=${payload.idPermissao}`, {}, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                if(response.data === false) {
                    commit('setIsSentRequestInstiUser', true)
                } else {
                    commit('setIsSentRequestInstiUser', false)
                }
            })
            .catch((error) => {
                console.log(error.message)
                commit('setIsSentRequestInstiUser', false)
            })
    },

    //-- ACTION INVITE USUÁRIO PARA A PLATAFORMA
    //-- Adm Municipal, Assistente de Campo e Avaliar => 4,3,1
    async setNotifyMunicInviteUser({commit}, payload) {
        await axios
            .post(`usuarios/register-invite/${payload.userMails}?idRegional=${payload.idRegional}&idMunicipio=${payload.idMunicipio}&idPermissao=${payload.idPermissao}`, {}, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                if(response.data === false) {
                    commit('setIsSentRequestInstiUser', true)
                } else {
                    commit('setIsSentRequestInstiUser', false)
                }
            })
            .catch((error) => {
                console.log(error.message)
                commit('setIsSentRequestInstiUser', false)
            })
    },

    //-- ACTION INVITE USUÁRIO PARA A PLATAFORMA
    //-- Gestor Escolar => 2
    async setNotifyUeInviteUser({commit}, payload) {
        await axios
            .post(`usuarios/register-invite/${payload.userMails}?idRegional=${payload.idRegional}&idMunicipio=${payload.idMunicipio}&idUnidade=${payload.idUe}&idPermissao=${payload.idPermissao}`, {}, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                if(response.data === false) {
                    commit('setIsSentRequestInstiUser', true)
                } else {
                    commit('setIsSentRequestInstiUser', false)
                }
            })
            .catch((error) => {
                console.log(error.message)
                commit('setIsSentRequestInstiUser', false)
            })
    },

    //-- ACTION REQUISICAO RETORNO DAS SOLICITACOES DA INSTI
    async setListInstiRequests({ commit }, payload) {
        await axios
            .get(`notificacoes/insti/${payload.idInstituicao}?notiTypes[]=USUARIO_INSTITUICAO`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListInstiRequests', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO RETORNO DAS SOLICITACOES DO USER
    async setListUserRequests({ commit }) {
        await axios
            .get(`notificacoes/user/?notiTypes[]=INSTITUICAO_USUARIO`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListUserRequests', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION PARA ACEITAR/RECUSAR AS SOLICITACOES DA INSTI
    async setStatusInstiRequest( _, payload)  {
        await axios
            .put(`notificacoes/insti/${payload.idInstituicao}/${payload.idSolicitacao}`, {
                isAceito: payload.isAceito
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {})
            .catch((error) => console.log(error.message))
    },

    //-- ACTION PARA ACEITAR/RECUSAR AS SOLICITACOES DO USER
    async setStatusUserRequest( _, payload)  {
        await axios
            .put(`notificacoes/user/${payload.idSolicitacao}`, {
                isAceito: payload.isAceito
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {})
            .catch((error) => console.log(error.message))
    },

}

// GETTERS
const getters = {
    getListInstiRequests(state) {
        try {
            return state.listInstiRequests.data
        } catch (e) {
            return []
        }
    },

    getListUserRequests(state) {
        try {
            return state.listUserRequests.data
        } catch (e) {
            return []
        }
    },

    getIsSentRequestUserInsti(state) {
        return state.isSentRequestUserInsti
    },

    getIsSentRequestInstiUser(state) {
        return state.isSentRequestInstiUser
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}

